import { ReactElement } from 'react';
import cn from 'classnames';

import styles from './Icon.module.scss';

import { ReactComponent as Alert } from '../../images/vectors/alert.svg';
import { ReactComponent as AlertMegaphone } from '../../images/vectors/alert_megaphone.svg';
import { ReactComponent as Basket } from '../../images/vectors/basket.svg';
import { ReactComponent as Checked } from '../../images/vectors/checked.svg';
import { ReactComponent as Link } from '../../images/vectors/link.svg';
import { ReactComponent as Mail } from '../../images/vectors/mail.svg';
import { ReactComponent as Next } from '../../images/vectors/next.svg';
import { ReactComponent as Phone } from '../../images/vectors/phone.svg';
import { ReactComponent as Play } from '../../images/vectors/play.svg';
import { ReactComponent as Edit } from '../../images/vectors/edit.svg';
import { ReactComponent as Download } from '../../images/vectors/download.svg';
import { ReactComponent as Plus } from '../../images/vectors/plus.svg';
import { ReactComponent as Document } from '../../images/vectors/document.svg';
import { ReactComponent as DocumentText } from '../../images/vectors/document-text.svg';
import { ReactComponent as Good } from '../../images/vectors/good.svg';
import { ReactComponent as Neutral } from '../../images/vectors/neutral.svg';
import { ReactComponent as Bad } from '../../images/vectors/bad.svg';
import { ReactComponent as Refresh } from '../../images/vectors/refresh.svg';
import { ReactComponent as Search } from '../../images/vectors/search.svg';
import { ReactComponent as Info } from '../../images/vectors/info.svg';
import { ReactComponent as CheckmarkCircle } from '../../images/vectors/checkmark-circle.svg';
import { ReactComponent as Close } from '../../images/vectors/close.svg';
import { ReactComponent as Union } from '../../images/vectors/union.svg';

export interface IconProps {
    name:
        | 'alert'
        | 'alertMegaphone'
        | 'basket'
        | 'checked'
        | 'link'
        | 'mail'
        | 'next'
        | 'phone'
        | 'play'
        | 'edit'
        | 'download'
        | 'plus'
        | 'document'
        | 'document-text'
        | 'good'
        | 'neutral'
        | 'bad'
        | 'refresh'
        | 'search'
        | 'info'
        | 'checkmark-circle'
        | 'close'
        | 'union';
    size?: 'small' | 'medium' | 'large';
    className?: string;
}

export const Icon = ({ name, size, className, ...props }: IconProps): ReactElement | null => {
    const renderIcon = () => {
        switch (name) {
            case 'alert':
                return <Alert {...props} />;
            case 'alertMegaphone':
                return <AlertMegaphone {...props} />;
            case 'basket':
                return <Basket {...props} />;
            case 'checked':
                return <Checked {...props} />;
            case 'link':
                return <Link {...props} />;
            case 'mail':
                return <Mail {...props} />;
            case 'next':
                return <Next {...props} />;
            case 'phone':
                return <Phone {...props} />;
            case 'play':
                return <Play {...props} />;
            case 'edit':
                return <Edit {...props} />;
            case 'download':
                return <Download {...props} />;
            case 'plus':
                return <Plus {...props} />;
            case 'document':
                return <Document {...props} />;
            case 'document-text':
                // TODO: dočasné řešení velikosti ikony
                return <DocumentText width={20} height={20} {...props} />;
            case 'good':
                return <Good {...props} />;
            case 'neutral':
                return <Neutral {...props} />;
            case 'bad':
                return <Bad {...props} />;
            case 'refresh':
                return <Refresh {...props} />;
            case 'search':
                return <Search {...props} />;
            case 'info':
                return <Info width={18} height={18} {...props} />;
            case 'checkmark-circle':
                return <CheckmarkCircle {...props} />;
            case 'close':
                return <Close {...props} />;
            case 'union':
                return <Union {...props} />;
            default:
                return <Alert {...props} />;
        }
    };

    return (
        <div className={cn(styles.wrapper, size && styles[size], className)} {...props}>
            {renderIcon()}
        </div>
    );
};
